/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import "@fontsource/hind/400.css"
import "@fontsource/hind/700.css"
import "@fontsource/poppins/700.css"
import "./src/styles/global.css"
import { storeTrackingParamsFromUrl } from "./utils/cookieUtils"
import { getApiBase } from "./utils/getApiBase"

// Initialize session with first touch data
const initSession = async () => {
  if (typeof window === "undefined") return

  // Check if we already have a session cookie
  const hasSession = document.cookie.includes("QuiliaSession=")
  if (hasSession) return

  const urlParams = new URLSearchParams(window.location.search)
  const data = {
    first_touch: {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      referrer: document.referrer,
      utm_source: urlParams.get("utm_source"),
      utm_medium: urlParams.get("utm_medium"),
      utm_campaign: urlParams.get("utm_campaign"),
      utm_term: urlParams.get("utm_term"),
      utm_content: urlParams.get("utm_content"),
      gclid: urlParams.get("gclid"),
      fbclid: urlParams.get("fbclid"),
      ttclid: urlParams.get("ttclid"),
      msclkid: urlParams.get("msclkid")
    }
  }

  try {
    const API_BASE = getApiBase()
    const response = await fetch(`${API_BASE}/api/init-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
  } catch (error) {
    console.error("Error initializing session:", error)
  }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Store tracking parameters if present in URL
  storeTrackingParamsFromUrl()

  // Initialize session on first page load
  if (!prevLocation) {
    initSession()
  }

  // Check if there's a query string in the URL
  if (location.search && location.search.includes("?btn_text=")) {
    const urlWithoutQuery = location.pathname
    // Use window.location.replace for a 301-like redirect (no browser history)
    window.location.replace(urlWithoutQuery)
  }
}
